// Web mock for react-native-splash-screen (no native splash on web).
export default {
  hide() {},
  show() {},
};
